import { useState, useCallback } from "react";
import API from "../../api/apiAdmin";

export function useAllProducts() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchAllProducts = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await API.get("/admin/inventory/all-products/");
            return res.data;
        } catch (err) {
            const msg = err.response?.data?.message || "Failed to fetch all products.";
            setError(msg);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        loading,
        error,
        fetchAllProducts
    };
}
